import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  IconButton,
  MenuItem,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { css, StyleSheet } from "aphrodite";
import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { FilterAlunos } from "../../components/filter/FilterAlunos";
import { v4 as uuidv4 } from "uuid";
import {
  CustomDatagrid,
  CustomRowBase,
} from "../../components/datagrid/CustomDatagrid";
import {
  Add,
  AddCard,
  BookmarkAdd,
  Delete,
  DeleteOutline,
  EditDocument,
  FileUpload,
  GroupOutlined,
  People,
} from "@mui/icons-material";
import Colors from "../../components/constants/Colors";
import axios from "axios";
import { headers, headersFBT } from "../../components/core/store/localStorage";
import { cleanCurrency } from "../../helpers/valor";
import errorHandler from "../../components/core/store/errorHandler";
import { ValidationDialog } from "../../components/modals/RequiredModal";
import { isCpfFormat, isEmailValid } from "../../helpers/required";
import { formatCPF, formatTelefone, parseDecimal } from "../../helpers/format";
import { TAG_OPTIONS, TagValue } from "../../helpers/tagOptions";
import { fileToBase64 } from "../../helpers/fileToBase64";
import { isValidCPF } from "../../helpers/isValidCpf";
import { getSituacaoId, getSituacaoLabel } from "../../helpers/getSituacaoId";

const currentUser = sessionStorage.getItem("userName");
const currentEmp = sessionStorage.getItem("empName");
const API_URL = sessionStorage.getItem("apiUrl");
const PAGE_SIZE = 30;

type DocRow = {
  tag: TagValue | "";
  file: File | null;
  file64?: string;
  documentoId?: string;
  alunoId?: string;
  dirty?: boolean;
};
type Aluno = {
  id: string;
  nome: string;
  matricula?: {
    id: string;
  };
};
type CobrancaRow = {
  cobrancaId: string;
  statusCobranca: string;
  valorTotal: string;
  dataVencimento: string;
  textoParcela: string;
  ordemParcela: string;
  valorPago: string;
  dataPagamento: string;
};

export const Alunos = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const id = window.location.href;
  let link = "";
  link = id.includes("?page=") ? id.charAt(38) : "";

  const [searchValue, setSearchValue] = useState("");
  const [registerStudent, setRegisterStudent] = useState(false);
  const [telaInicial, setTelaInicial] = useState(false);
  const [isWaiting, setIsWaiting] = useState(false);
  const [editingStudent, setEditingStudent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [titleLoading, setTitleLoading] = useState("Buscando Alunos...");
  const [notFound, setNotFound] = useState(false);
  const [page, setPage] = useState(0);
  const [rowCount, setRowCount] = useState(0);
  const [valModalOpen, setValModalOpen] = useState(false);
  const [valErrors, setValErrors] = useState<string[]>([]);
  const [trigger, setTrigger] = useState(false);
  const [searchSituacao, setSearchSituacao] = useState<string[]>([]);

  const [rows, setRows] = useState([]);
  const [idMatricula, setIdMatricula] = useState("");
  const [status, setStatus] = useState("ativado"); // 0 DESATIVADO, 1 ATIVADO
  const [codTurma, setCodTurma] = useState("");
  const [codTurmaList, setCodTurmaList] = useState([]);
  const [codCurso, setCodCurso] = useState("");
  const [codCursoList, setCodCursoList] = useState([]);
  const [registro, setRegistro] = useState("");
  const [valorCurso, setValorCurso] = useState("");
  const [valorVenda, setValorVenda] = useState("");
  const [parcelas, setParcelas] = useState("");
  const [statusMatricula, setStatusMatricula] = useState("ativado");
  const [hasWarningOnly, setHasWarningOnly] = useState(false);

  // INFORMAÇÕES DO ALUNO
  const [cpf, setCpf] = useState("");
  const [email, setEmail] = useState("");
  const [nome, setNome] = useState("");
  const [logradouro, setLogradouro] = useState("");
  const [numero, setNumero] = useState("");
  const [bairro, setBairro] = useState("");
  const [cidadeIBGE, setCidadeIBGE] = useState("");
  const [cep, setCep] = useState("");
  const [telCelular, setTelCelular] = useState("");
  const [sexo, setSexo] = useState(""); // 0 MASCULINO, 1 FEMININO
  const [nascimento, setNascimento] = useState("");

  // INFORMAÇÕES DE COBRANÇA
  const [statusCobranca, setStatusCobranca] = useState("");
  const [valorTotal, setValorTotal] = useState("");
  const [dataVencimento, setDataVencimento] = useState("");
  const [textoParcela, setTextoParcela] = useState("");
  const [ordemParcela, setOrdemParcela] = useState("");
  const [valorPago, setValorPago] = useState("");
  const [dataPagamento, setDataPagamento] = useState("");
  const [cobrancas, setCobrancas] = useState<CobrancaRow[]>([
    {
      cobrancaId: "",
      statusCobranca: "",
      valorTotal: "",
      dataVencimento: "",
      textoParcela: "",
      ordemParcela: "",
      valorPago: "",
      dataPagamento: "",
    },
  ]);

  // DOCUMENTOS
  const [tag, setTag] = useState("");
  const [documento, setDocumento] = useState<File | null>(null);
  const [docs, setDocs] = useState<DocRow[]>([{ tag: "", file: null }]);

  const fileInputsRef = useRef<HTMLInputElement[]>([]);

  // FILTRAGEM
  const [searchCpf, setSearchCpf] = useState("");
  const [searchNome, setSearchNome] = useState("");
  const [searchEmail, setSearchEmail] = useState("");

  const lastAutoFilledCep = useRef<string | null>(null);
  const debounceId = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [dataParcela, setDataParcela] = useState("");

  useEffect(() => {
    setDocumento(null);
  }, [tag]);

  useEffect(() => {
    getCodCurso();
    getCodTurma();
    if (API_URL === null) window.location.href = "/";
  }, []);

  useEffect(() => {
    const digits = cep.replace(/\D/g, "");

    if (debounceId.current) clearTimeout(debounceId.current);

    if (digits.length === 8 && digits !== lastAutoFilledCep.current) {
      debounceId.current = setTimeout(async () => {
        try {
          const resp = await fetch(`https://viacep.com.br/ws/${digits}/json/`);
          const data = await resp.json();

          if (!data?.erro) {
            setLogradouro((prev) =>
              prev.trim() === "" ? (data.logradouro ?? "") : prev,
            );
            setBairro((prev) =>
              prev.trim() === "" ? (data.bairro ?? "") : prev,
            );

            if (data.ibge) setCidadeIBGE(data.ibge);

            lastAutoFilledCep.current = digits;
          }
        } catch (e) {}
      }, 300);
    }

    return () => {
      if (debounceId.current) clearTimeout(debounceId.current);
    };
  }, [cep]);

  useEffect(() => {
    if (!parcelas || isNaN(Number(parcelas))) return;

    const numParcelas = parseInt(parcelas);
    if (numParcelas <= 0) return;

    const baseDate = dataParcela
      ? (() => {
          const [year, month, day] = dataParcela.split("-").map(Number);
          return new Date(year, month - 1, day);
        })()
      : null;

    const addMonthsAndFormat = (date: Date, monthsToAdd: number) => {
      const d = new Date(date);
      d.setMonth(d.getMonth() + monthsToAdd);

      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    setCobrancas((prev) => {
      let novas = [...prev];

      if (numParcelas > prev.length) {
        for (let i = prev.length; i < numParcelas; i++) {
          novas.push({
            cobrancaId: uuidv4(),
            statusCobranca: "",
            valorTotal: valorVenda || "",
            dataVencimento: "",
            textoParcela: "",
            ordemParcela: "",
            valorPago: "",
            dataPagamento: "",
          });
        }
      }

      if (numParcelas < prev.length) {
        novas = novas.slice(0, numParcelas);
      }

      novas = novas.map((c, index) => {
        let vencimento = c.dataVencimento;

        if (baseDate) {
          vencimento = addMonthsAndFormat(baseDate, index);
        }

        return {
          ...c,
          textoParcela: `${index + 1}/${numParcelas}`,
          ordemParcela: (index + 1).toString(),
          valorTotal: valorVenda || "",
          dataVencimento: vencimento,
        };
      });

      return novas;
    });
  }, [parcelas, valorVenda, dataParcela]);

  const getCodCurso = () => {
    axios
      .get(`${API_URL}/curso/combo`, headers())
      .then((response) => {
        if (!response.data || !response.data)
          throw new Error("Estrutura de dados inválida");

        const resp = response.data.map((curso: any) => ({
          value: curso.id,
          label: curso.descricao,
          ativo: !curso.inativo,
        }));
        setCodCursoList(resp);
      })
      .catch((err) => {
        console.error("Erro ao buscar códigos de curso:", {
          message: err.message,
          response: err.response?.data,
          stack: err.stack,
        });
        errorHandler(err);
      });
  };
  const getCodTurma = () => {
    axios
      .get(`${API_URL}/turma/combo`, headers())
      .then((response) => {
        if (!response.data || !response.data)
          throw new Error("Estrutura de dados inválida");

        const resp = response.data.map((turma: any) => ({
          value: turma.id,
          label: turma.descricao,
          ativo: !turma.inativo,
        }));
        setCodTurmaList(resp);
      })
      .catch((err) => {
        console.error("Erro ao buscar códigos de turma:", {
          message: err.message,
          response: err.response?.data,
          stack: err.stack,
        });
        errorHandler(err);
      });
  };

  const handleAddRowCobranca = () =>
    setCobrancas((prev) => [
      ...prev,
      {
        cobrancaId: "",
        statusCobranca: "",
        valorTotal: "",
        dataVencimento: "",
        textoParcela: "",
        ordemParcela: "",
        valorPago: "",
        dataPagamento: "",
      },
    ]);

  const handleRemoveRowCobranca = async (index: number) => {
    const cobranca = cobrancas[index];
    // console.log(cobranca);
    if (!cobranca) return;

    if (!window.confirm("Remover esta cobrança?")) return;

    setCobrancas((prev) => prev.filter((_, i) => i !== index));

    if (!cobranca.ordemParcela) return;

    const alunoId = cpf;
    const ordemParcela = cobranca.ordemParcela;

    try {
      await axios.delete(
        `${API_URL}/aluno/${alunoId}/cobranca?parcela=${ordemParcela}`,
        headers(),
      );
    } catch (err) {
      console.error("Falha ao deletar cobrança:", err);

      setCobrancas((prev) => {
        const clone = [...prev];
        clone.splice(index, 0, cobranca);
        return clone;
      });
    }
  };

  const setField = <K extends keyof CobrancaRow>(
    index: number,
    field: K,
    value: CobrancaRow[K],
  ) =>
    setCobrancas((prev) => {
      const next = [...prev];
      next[index] = { ...next[index], [field]: value };
      return next;
    });

  const setDateField = (
    index: number,
    field: "dataVencimento" | "dataPagamento",
    val: string,
  ) => {
    const [ano = "", mes = "", dia = ""] = val.split("-");
    if (ano.length > 4) {
      const ajustado = `${ano.slice(0, 4)}-${mes}-${dia}`.replace(/-+$/g, "");
      setField(index, field, ajustado);
    } else {
      setField(index, field, val);
    }
  };

  const setCurrencyField = (
    index: number,
    field: "valorTotal" | "valorPago",
    raw: string,
  ) => {
    formatCurrency(raw, (masked: string) => setField(index, field, masked));
  };

  const handleFileSelected = (index: number, file: File | null) =>
    setDocs((prev) => {
      const next = [...prev];
      next[index] = { ...next[index], file, dirty: true };
      return next;
    });

  const handleAddRow = () =>
    setDocs((prev) => [...prev, { tag: "", file: null }]);

  const handleRemoveRow = async (index: number) => {
    const doc = docs[index];
    if (!doc) return;

    if (!window.confirm("Remover este documento?")) return;

    setDocs((prev) => prev.filter((_, i) => i !== index));

    if (!doc.documentoId) return;

    const alunoId = doc.alunoId ?? cpf;
    const documentoId = doc.documentoId;

    try {
      await axios.delete(
        `${API_URL}/aluno/${alunoId}/documento?documentoId=${documentoId}`,
        headers(),
      );
    } catch (err) {
      console.error("Falha ao deletar no servidor, desfazendo remoção:", err);
      setDocs((prev) => {
        const clone = [...prev];
        clone.splice(index, 0, doc);
        return clone;
      });
    }
  };

  const handleTagChange = (index: number, value: TagValue) =>
    setDocs((prev) => {
      const next = [...prev];
      next[index] = { ...next[index], tag: value };
      return next;
    });

  const triggerFilePicker = (index: number) => {
    fileInputsRef.current[index]?.click();
  };

  const searchStudents = async () => {
    setTitleLoading("Buscando alunos...");
    setTelaInicial(false);
    setNotFound(false);
    setLoading(true);
    await getAlunos();
  };

  useEffect(() => {
    getAlunos();
  }, [page]);

  const getAlunos = async () => {
    setLoading(true);
    try {
      const apiPage = page + 1;
      let url = `${API_URL}/aluno?page=${apiPage}`;

      if (searchCpf) url += `&cpf=${searchCpf}`;
      if (searchNome) url += `&nome=${searchNome}`;
      if (searchEmail) url += `&email=${searchEmail}`;
      if (Array.isArray(searchSituacao) && searchSituacao.length > 0) {
        const situacaoParam = searchSituacao
          .map((s) => `'${String(s).trim()}'`)
          .join(",");

        url += `&situacao=${encodeURIComponent(situacaoParam)}`;
      }

      const response = await axios.get(url, headers());

      // console.log(JSON.stringify(response.data, null, 2));

      const { alunos, totalPages } = response.data;

      if (!alunos || alunos.length === 0) {
        setRows([]);
        setTelaInicial(false);
        setNotFound(true);
        setRowCount(totalPages ? totalPages * PAGE_SIZE : 0);
        return;
      }

      const alunosFormatados = alunos.map((aluno: Aluno) => ({
        ...aluno,
        idMatricula: aluno.matricula?.id,
      }));

      setTelaInicial(true);
      setRows(alunosFormatados);
      setRowCount((totalPages ?? 0) * PAGE_SIZE);
    } catch (err: any) {
      console.error("Erro ao buscar alunos:", {
        message: err.message,
        response: err.response?.data,
        stack: err.stack,
      });
      setTrigger(false);
      setTelaInicial(false);
      setNotFound(true);
      errorHandler(err);
    } finally {
      setLoading(false);
    }
  };

  const formatCurrency = (
    value: string,
    setStateFunction: (value: string) => void,
  ) => {
    const onlyNumbers = value.replace(/\D/g, "");

    if (onlyNumbers === "") {
      setStateFunction("");
      return;
    }

    const numberValue = Number(onlyNumbers) / 100;

    const formattedValue = numberValue.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });

    setStateFunction(formattedValue);
  };

  const iniciarCadastro = () => {
    setStatusMatricula("ativado");
    setTrigger(true);
    setLoading(false);
    setTelaInicial(false);
    setNotFound(false);
    setDataParcela("");
    setIdMatricula("");
    setStatus("ativado");
    setCodTurma("");
    setCodCurso("");
    setRegistro("");
    setValorCurso("");
    setValorVenda("");
    setParcelas("");
    setCpf("");
    setEmail("");
    setNome("");
    setLogradouro("");
    setNumero("");
    setBairro("");
    setCidadeIBGE("");
    setCep("");
    setTelCelular("");
    setSexo("");
    setNascimento("");
    setRegisterStudent(true);
    setEditingStudent(false);
  };

  const handleBack = async () => {
    setStatusMatricula("ativado");
    setNotFound(false);
    setTrigger(false);
    setIdMatricula("");
    setSearchCpf("");
    setDataParcela("");
    setSearchNome("");
    setSearchEmail("");
    setStatus("");
    setCodTurma("");
    setCodCurso("");
    setRegistro("");
    setValorCurso("");
    setValorVenda("");
    setParcelas("");
    setCpf("");
    setEmail("");
    setNome("");
    setLogradouro("");
    setNumero("");
    setBairro("");
    setCidadeIBGE("");
    setCep("");
    setTelCelular("");
    setSexo("");
    setNascimento("");
    setRegisterStudent(false);
    setEditingStudent(false);
    setStatusCobranca("");
    setValorTotal("");
    setDataVencimento("");
    setTextoParcela("");
    setOrdemParcela("");
    setValorPago("");
    setDataPagamento("");
    setDocs([{ tag: "", file: null }]);
    setCobrancas([
      {
        cobrancaId: "",
        statusCobranca: "",
        valorTotal: "",
        dataVencimento: "",
        textoParcela: "",
        ordemParcela: "",
        valorPago: "",
        dataPagamento: "",
      },
    ]);
  };

  const cadastrarAluno = async (force = false) => {
    try {
      setIsWaiting(true);
      const errors: string[] = [];

      let isValid = isValidCPF(cpf);
      if (!editingStudent) {
        if (!idMatricula || !idMatricula.trim()) {
          errors.push("Informe o id da matrícula.");
        } else {
          const response = await axios.get(
            `${API_URL}/aluno/criticar?idMatricula=${idMatricula}`,
            headers(),
          );
          if (response.data.existe)
            errors.push("Número da matrícula já cadastrada.");
        }
      }
      if (!cpf || !cpf.trim()) errors.push("Informe o CPF.");
      else if (!isCpfFormat(cpf)) errors.push("CPF inválido (use 11 dígitos).");
      else if (!isValid) errors.push("Digite um CPF válido");
      if (!email || !email.trim()) errors.push("Informe o e-mail.");
      else if (!isEmailValid(email)) errors.push("E-mail inválido.");
      if (!nome || !nome.trim()) errors.push("Informe o nome.");
      if (!cep || !cep.trim()) errors.push("Informe o CEP.");
      if (!numero || !numero.trim()) errors.push("Informe o número.");
      if (!bairro || !bairro.trim()) errors.push("Informe o bairro.");
      if (!cidadeIBGE || !cidadeIBGE.trim())
        errors.push("Informe o cidadeIBGE.");

      const hasCompleteDocument = docs.some(
        (doc) =>
          doc.tag &&
          doc.tag.trim() !== "" &&
          (doc.file !== null ||
            (typeof doc.file64 === "string" && doc.file64.trim() !== "")),
      );
      if (!hasCompleteDocument)
        errors.push(
          "Selecione pelo menos uma tag e seu documento correspondente.",
        );

      const mesesPagos = (cobrancas ?? [])
        .map((c) => c.dataPagamento?.trim())
        .filter((d) => !!d)
        .map((d) => d.slice(0, 7));

      const temMesDuplicado = new Set(mesesPagos).size !== mesesPagos.length;

      if (temMesDuplicado && !force) {
        errors.push("Existe mais de uma parcela paga no mesmo mês/ano.");
      }

      if (errors.length) {
        const soTemAvisoDeMes =
          errors.length === 1 && temMesDuplicado && !force;
        setHasWarningOnly(soTemAvisoDeMes);

        setValErrors(errors);
        setValModalOpen(true);
        setIsWaiting(false);
        return;
      }

      const payload = {
        id: cpf,
        cpf,
        email,
        nome,
        logradouro,
        numero,
        bairro,
        cidadeIBGE,
        inativo: false,
        cep,
        telCelular,
        sexo: sexo.trim().toLowerCase() === "masculino" ? "M" : "F",
        nascimento: nascimento ? nascimento : undefined,
        dataParcela: dataParcela || undefined,
        matricula: {
          id: idMatricula,
          status: status.trim().toLowerCase() === "desativado" ? "0" : "1",
          codigoTurma: codTurma,
          codigoCurso: codCurso,
          registro,
          idSituacao: getSituacaoId(statusMatricula),
          valorCurso: cleanCurrency(valorCurso),
          valorVenda: cleanCurrency(valorVenda),
          parcelas,
        },
      };

      const normalizedCobrancas = (cobrancas ?? []).map((c) => ({
        cobrancaId: editingStudent ? c.cobrancaId || uuidv4() : uuidv4(),
        status: (c?.statusCobranca ?? "").trim(),
        valorTotal: cleanCurrency(c?.valorTotal ?? ""),
        dataVencimento: (c?.dataVencimento ?? "").trim(),
        textoParcela: (c?.textoParcela ?? "").trim(),
        ordemParcela: (c?.ordemParcela ?? "").trim(),
        valorPago: cleanCurrency(c?.valorPago ?? ""),
        dataPagamento: (c?.dataPagamento ?? "").trim(),
      }));

      const payloadCobranca = normalizedCobrancas.filter(
        (c) =>
          c.cobrancaId ||
          c.status ||
          c.valorTotal ||
          c.dataVencimento ||
          c.textoParcela ||
          c.ordemParcela ||
          c.valorPago ||
          c.dataPagamento,
      );

      const payloadDocumento = await Promise.all(
        (docs ?? []).map(async (d) => {
          const file64 = d?.file
            ? await fileToBase64(d.file)
            : typeof d?.file64 === "string"
              ? d.file64
              : "";

          const isNew = !d.documentoId;

          return {
            matriculaId: (idMatricula ?? "").trim(),
            tag: (d?.tag ?? "").trim() || "",
            file64,
            documentoId: d.documentoId || uuidv4(),
            isNew,
            dirty: !!d.dirty,
          };
        }),
      );

      const documentosParaAtualizar = payloadDocumento.filter(
        (doc) => doc.tag && doc.file64 && (doc.isNew || doc.dirty),
      );

      const documentosNovos = payloadDocumento.filter((doc) => doc.isNew);

      if (editingStudent) {
        const payloadAttAluno = {
          change: "atualizar-aluno",
          data: {
            aluno: {
              status: "1",
              cpf,
              nome,
              cep,
              nascimento: nascimento ? nascimento : undefined,
              sexo_pf: sexo.trim().toLowerCase() === "masculino" ? "M" : "F",
              logradouro,
              numero,
              complemento: "",
              bairro,
              telCelular: telCelular?.trim() ? telCelular : undefined,
              telFixo: undefined,
            },
          },
        };

        // console.log(JSON.stringify(payloadAttAluno, null, 2));

        try {
          await axios.post(
            `https://minha.fbtedu.com.br/admin/modules/mod_esat/`,
            payloadAttAluno,
            headersFBT(),
          );
        } catch (e) {
          console.error("Erro na primeira requisição (atualizar-aluno):", e);
          setIsWaiting(false);

          const retorno = errorHandler(e);
          const msgRaw = retorno?.erro?.mensagem;

          let mensagem;

          if (typeof msgRaw === "string") {
            mensagem = msgRaw;
          } else if (msgRaw && msgRaw.message) {
            mensagem = msgRaw.message;
          } else {
            mensagem = "Ocorreu um erro ao comunicar com o portal FBT.";
          }

          alert(mensagem);

          return;
        }

        const payloadAttMatricula = {
          change: "atualizar-matricula",
          data: {
            matricula: {
              id: idMatricula,
              idSituacao: getSituacaoId(statusMatricula),
              ...(documentosParaAtualizar.length > 0 && {
                documentos: documentosParaAtualizar.map((d) => ({
                  tag: d.tag,
                  file64: d.file64,
                })),
              }),
            },
          },
        };

        // console.log(JSON.stringify(payloadAttMatricula, null, 2));

        // console.log(JSON.stringify(payloadAttMatricula, null, 2));
        await axios.post(
          `https://minha.fbtedu.com.br/admin/modules/mod_esat/`,
          payloadAttMatricula,
          headersFBT(),
        );

        const payloadAttCobranca = {
          change: "atualizar-cobranca",
          data: {
            cobrancas: payloadCobranca.map((c) => ({
              id: c.cobrancaId,
              status: "1",
              valorPago: parseDecimal(c.valorPago)?.toString() ?? "0",
              dataVencimento: c.dataVencimento,
              dataPagamento: c.dataPagamento,
              textoParcela: c.textoParcela,
              vencimentoDesconto: "",
              valorComDesconto: "",
              ordemParcela: c.ordemParcela,
            })),
          },
        };

        // console.log(JSON.stringify(payloadAttCobranca, null, 2));
        await axios.post(
          `https://minha.fbtedu.com.br/admin/modules/mod_esat/`,
          payloadAttCobranca,
          headersFBT(),
        );
      } else {
        const payloadCombinado = {
          change: "nova-matricula",
          data: {
            matricula: {
              id: payload.matricula.id,
              status: payload.matricula.status,
              codigoTurma: payload.matricula.codigoTurma,
              codigoCurso: payload.matricula.codigoCurso,
              registro: payload.matricula.registro,
              valorCurso:
                parseDecimal(payload.matricula.valorCurso)?.toString() ?? "0",
              valorVenda:
                parseDecimal(payload.matricula.valorVenda)?.toString() ?? "0",
              parcelas: payload.matricula.parcelas,
            },
            aluno: {
              cpf: payload.cpf,
              email: payload.email,
              nome: payload.nome,
              logradouro: payload.logradouro,
              numero: payload.numero,
              bairro: payload.bairro,
              cidadeIBGE: payload.cidadeIBGE,
              cep: payload.cep,
              telCelular: payload.telCelular,
              sexo: payload.sexo,
              nascimento: payload.nascimento,
            },
            cobrancas: (payloadCobranca || []).map((c) => ({
              id: c.cobrancaId,
              status: "1",
              valorTotal: parseDecimal(c.valorTotal)?.toString() ?? "0",
              dataVencimento: c.dataVencimento,
              textoParcela: c.textoParcela,
              ordemParcela: c.ordemParcela,
              valorPago: parseDecimal(c.valorPago)?.toString() ?? "0",
              dataPagamento: c.dataPagamento,
            })),
          },
        };

        // console.log(JSON.stringify(payloadCombinado, null, 2));

        try {
          await axios.post(
            `https://minha.fbtedu.com.br/admin/modules/mod_esat/`,
            payloadCombinado,
            headersFBT(),
          );
        } catch (e) {
          console.error("Erro na primeira requisição (nova-matricula):", e);
          setIsWaiting(false);

          const retorno = errorHandler(e);
          const msgRaw = retorno?.erro?.mensagem;

          let mensagem;

          if (typeof msgRaw === "string") {
            mensagem = msgRaw;
          } else if (msgRaw && msgRaw.message) {
            mensagem = msgRaw.message;
          } else {
            mensagem =
              "Erro ao comunicar com o portal FBT na criação da matrícula.";
          }

          alert(mensagem);

          return;
        }

        await new Promise((resolve) => setTimeout(resolve, 2000));

        const payloadAttMatricula = {
          change: "atualizar-matricula",
          data: {
            matricula: {
              id: idMatricula,
              idSituacao: "1",
              documentos: payloadDocumento.map((d) => ({
                tag: d.tag,
                file64: d.file64,
              })),
            },
          },
        };

        // console.log(JSON.stringify(payloadAttMatricula, null, 2));
        await axios.post(
          `https://minha.fbtedu.com.br/admin/modules/mod_esat/`,
          payloadAttMatricula,
          headersFBT(),
        );
      }
      await axios.post(`${API_URL}/aluno`, payload, headers());
      await axios.post(
        `${API_URL}/aluno/${cpf}/documento/batch`,
        payloadDocumento,
        headers(),
      );
      await axios.post(
        `${API_URL}/aluno/${cpf}/cobranca/batch`,
        payloadCobranca,
        headers(),
      );
    } catch (err) {
      errorHandler(err);
      console.log(err);
    }

    setStatusMatricula("ativado");
    setTrigger(false);
    setIsWaiting(false);
    setSearchCpf("");
    setSearchNome("");
    setSearchEmail("");
    setIdMatricula("");
    setStatus("");
    setCodTurma("");
    setCodCurso("");
    setRegistro("");
    setValorCurso("");
    setValorVenda("");
    setParcelas("");
    setCpf("");
    setEmail("");
    setNome("");
    setLogradouro("");
    setNumero("");
    setBairro("");
    setCidadeIBGE("");
    setCep("");
    setTelCelular("");
    setSexo("");
    setNascimento("");
    setRegisterStudent(false);
    setEditingStudent(false);
    setStatusCobranca("");
    setValorTotal("");
    setDataVencimento("");
    setTextoParcela("");
    setOrdemParcela("");
    setValorPago("");
    setDataPagamento("");
    setTag("");
    setDocs([{ tag: "", file: null }]);
    setCobrancas([
      {
        cobrancaId: "",
        statusCobranca: "",
        valorTotal: "",
        dataVencimento: "",
        textoParcela: "",
        ordemParcela: "",
        valorPago: "",
        dataPagamento: "",
      },
    ]);
  };

  // const testScript = async () => {
  //   const url = "https://minha.fbtedu.com.br/admin/modules/mod_esat/";
  //   const headersTeste = {
  //     "Content-Type": "application/json",
  //     Token:
  //       "a9504442555dbcefbfe99506fa0cef0d8b8fd58e2fb1908602633e5451b4cc2659aed8b2b70b0a7598aeec77028634229acbd0dc24999160b09c9c2a2703e3ed",
  //   };

  //   try {
  //     const response = await axios.post(
  //       url,
  //       {
  //         change: "buscar-documento",
  //         data: {
  //           matricula: {
  //             id: "21391",
  //             documento: {
  //               tag: "CertidaoNascimento",
  //             },
  //           },
  //         },
  //       },
  //       { headers: headersTeste }
  //     );

  //     return response.data;
  //   } catch (error) {
  //     throw error;
  //   }
  // };

  const handleEdit = async (r: CustomRowBase) => {
    // console.log(r);
    setLoading(true);
    setTitleLoading("Abrindo cadastro do aluno...");
    setTelaInicial(false);
    let url = `${API_URL}/aluno/resumo/${r.id}`;

    const response = await axios.get(url, headers());
    const p = response?.data || {};

    setCpf(String(r.id ?? ""));
    setEmail(r.email ?? "");
    setNome(r.nome ?? "");
    setCep(r.cep ?? "");
    setLogradouro(r.logradouro ?? "");
    setNumero(r.numero ?? "");
    setBairro(r.bairro ?? "");
    setCidadeIBGE(r.cidadeIBGE ?? "");
    setTelCelular(r.telCelular ?? "");
    setSexo(r.sexo === "M" ? "masculino" : "feminino");
    setNascimento(r.nascimento ?? "");
    setIdMatricula(r.matricula?.id ?? "");
    setStatusMatricula(getSituacaoLabel(r.matricula?.idSituacao ?? ""));
    setStatus(r.matricula?.status === "0" ? "desativado" : "ativado");
    setCodTurma(r.matricula?.codigoTurma ?? "");
    setCodCurso(r.matricula?.codigoCurso ?? "");
    setRegistro(r.matricula?.registro ?? "");
    setValorCurso(r.matricula?.valorCurso ?? "");
    setValorVenda(r.matricula?.valorVenda ?? "");
    setParcelas(r.matricula?.parcelas ?? "");

    const documentosArr = Array.isArray(p.documentos) ? p.documentos : [];
    const matriculaIdFromJson =
      String(documentosArr?.[0]?.matriculaId ?? "") ||
      String((p as any)?.matriculaId ?? "");

    // setIdMatricula(matriculaIdFromJson);

    const docs = documentosArr.map((d: any) => ({
      id: String(d.id ?? `${p.id ?? r.id ?? ""}_${d.documentoId ?? ""}`),
      tag: String(d.tag ?? ""),
      file64: String(d.file64 ?? ""),
      alunoId: String(d.alunoId ?? p.id ?? r.id ?? ""),
      documentoId: String(d.documentoId ?? ""),
      matriculaId: String(d.matriculaId ?? matriculaIdFromJson),
    }));
    setDocs(docs);

    const cobrancasArr = Array.isArray(p.cobrancas) ? p.cobrancas : [];
    const cobrancas: CobrancaRow[] = cobrancasArr
      .slice()
      .sort((a: any, b: any) => {
        const na = Number(a?.ordemParcela ?? 0);
        const nb = Number(b?.ordemParcela ?? 0);
        return na - nb;
      })
      .map((c: any) => ({
        cobrancaId: String(c.cobrancaId ?? ""),
        statusCobranca: String(c.status ?? ""),
        valorPago: String(c.valorPago ?? "0,00"),
        valorTotal: String(c.valorTotal ?? "0,00"),
        ordemParcela: String(c.ordemParcela ?? ""),
        textoParcela: String(c.textoParcela ?? ""),
        dataPagamento: String(c.dataPagamento ?? ""),
        dataVencimento: String(c.dataVencimento ?? ""),
      }));
    setCobrancas(cobrancas);
    setTrigger(true);
    setLoading(false);
    setEditingStudent(true);
    setRegisterStudent(false);
  };

  return (
    <>
      <Grid wrap="wrap">
        <Grid
          size={{ xs: 6, sm: 7, md: 8, xl: 10 }}
          style={{
            marginTop: "-1.6rem",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h3 className={css(styles.pageTitle)} style={{ marginRight: "4px" }}>
            {registerStudent ? "Cadastrar Aluno" : "Alunos"}
          </h3>
          <div style={{ display: "flex", gap: "15px" }}>
            {registerStudent || editingStudent ? (
              <button className={css(styles.topBtn)} onClick={handleBack}>
                Voltar
              </button>
            ) : (
              <Tooltip title={"Adicionar novo aluno"}>
                <button
                  disabled={loading}
                  onClick={iniciarCadastro}
                  className={
                    loading ? css(styles.btnDisabled) : css(styles.topBtn)
                  }
                >
                  <Add />
                </button>
              </Tooltip>
            )}
          </div>
        </Grid>
      </Grid>
      <hr
        style={{
          color: "#eee",
          marginTop: "-0.55rem",
          marginBottom: "1rem",
        }}
      />

      {!trigger ? (
        <FilterAlunos
          searchStudents={searchStudents}
          searchCpf={searchCpf}
          setSearchCpf={setSearchCpf}
          searchNome={searchNome}
          setSearchNome={setSearchNome}
          searchEmail={searchEmail}
          setSearchEmail={setSearchEmail}
          searchSituacao={searchSituacao}
          setSearchSituacao={setSearchSituacao}
        />
      ) : null}

      {telaInicial ? (
        <Box>
          <Box sx={{ width: "100%", display: "grid", gap: 2, marginTop: 2 }}>
            <CustomDatagrid
              rows={rows}
              visibleColumns={[
                "idMatricula",
                "id",
                "email",
                "nome",
                "telCelular",
                "sexo",
                "nascimento",
                "actions",
              ]}
              extraColumns={[
                { field: "id", headerName: "CPF", minWidth: 150, flex: 1 },
                {
                  field: "idMatricula",
                  headerName: "Matrícula",
                  minWidth: 120,
                  flex: 1,
                },
              ]}
              actions={["edit"]}
              onEdit={(r) => handleEdit(r)}
              loading={loading}
              paginationMode="server"
              paginationModel={{ page, pageSize: PAGE_SIZE }}
              onPaginationModelChange={(model) => {
                if (model.page !== page) setPage(model.page);
              }}
              rowCount={rowCount}
            />
          </Box>
        </Box>
      ) : null}

      {trigger ? (
        <Box sx={{ width: "100%", display: "grid", gap: 2, marginTop: 2 }}>
          <Card>
            <CardContent>
              <Grid container spacing={1}>
                <Grid size={{ xs: 12, md: 12 }}>
                  <Typography
                    sx={{
                      backgroundColor: Colors.titleRowWithBackgroundColor,
                      pl: 1,
                      pt: 0.75,
                      mt: -1,
                    }}
                    variant="body2"
                    color={Colors.titleWithBackgroudColor}
                  >
                    <BookmarkAdd fontSize={"inherit"} /> Informações de
                    Matrícula
                  </Typography>
                </Grid>

                <Grid size={{ xs: 12, sm: 3, lg: 1.5, xl: 0.75 }}>
                  <TextField
                    fullWidth
                    required
                    placeholder="Id"
                    value={idMatricula}
                    type="text"
                    onChange={(ev) => {
                      setIdMatricula(ev.target.value);
                    }}
                    size={"small"}
                    color="primary"
                    label="Id"
                    disabled={editingStudent}
                    sx={{
                      "& .MuiInputLabel-root.Mui-disabled": {
                        color: (theme) => theme.palette.text.disabled,
                      },
                      "& .MuiOutlinedInput-root.Mui-disabled": {
                        backgroundColor: (theme) =>
                          theme.palette.action.disabledBackground,
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: (theme) => theme.palette.action.disabled,
                        },
                      },
                      "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: (theme) =>
                          theme.palette.text.disabled,
                      },
                    }}
                  />
                </Grid>

                <Grid size={{ xs: 12, sm: 3, lg: 1.5, xl: 1 }}>
                  <TextField
                    fullWidth
                    select
                    label="Status"
                    size="small"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    <MenuItem value="ativado">Ativado</MenuItem>
                    <MenuItem value="desativado">Desativado</MenuItem>
                  </TextField>
                </Grid>

                <Grid size={{ xs: 12, sm: 6, lg: 2.5, xl: 3.32 }}>
                  <TextField
                    fullWidth
                    select
                    label="Código da Turma"
                    value={codTurma ?? ""}
                    onChange={(ev) => setCodTurma(ev.target.value)}
                    size="small"
                    color="primary"
                  >
                    {codTurmaList.map(({ value, label }) => (
                      <MenuItem key={value} value={value}>
                        {value} - {label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid size={{ xs: 12, sm: 6, lg: 2.5, xl: 3.32 }}>
                  <TextField
                    fullWidth
                    select
                    label="Código do Curso"
                    value={codCurso ?? ""}
                    onChange={(ev) => setCodCurso(ev.target.value)}
                    size="small"
                    color="primary"
                  >
                    {codCursoList.map(({ value, label }) => (
                      <MenuItem key={value} value={value}>
                        {value} - {label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid size={{ xs: 12, sm: 3, lg: 1.3 }}>
                  <TextField
                    fullWidth
                    placeholder="Registro"
                    value={registro}
                    type="date"
                    onChange={(ev) => {
                      const val = ev.target.value;
                      const [ano, mes, dia] = val.split("-");
                      if (ano && ano.length > 4) {
                        setRegistro(
                          `${ano.slice(0, 4)}-${mes || ""}-${dia || ""}`,
                        );
                      } else {
                        setRegistro(val);
                      }
                    }}
                    size="small"
                    color="primary"
                    label="Registro"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      maxLength: 10,
                    }}
                  />
                </Grid>

                <Grid size={{ xs: 12, sm: 3, lg: 1.3 }}>
                  <TextField
                    fullWidth
                    placeholder="Data da parcela"
                    value={dataParcela}
                    type="date"
                    onChange={(ev) => {
                      const val = ev.target.value;
                      const [ano, mes, dia] = val.split("-");
                      if (ano && ano.length > 4) {
                        setDataParcela(
                          `${ano.slice(0, 4)}-${mes || ""}-${dia || ""}`,
                        );
                      } else {
                        setDataParcela(val);
                      }
                    }}
                    size="small"
                    color="primary"
                    label="Data da parcela"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      maxLength: 10,
                    }}
                  />
                </Grid>

                <Grid size={{ xs: 12, sm: 3, lg: 2.5, xl: 1 }}>
                  <TextField
                    fullWidth
                    placeholder="Valor do Curso"
                    value={valorCurso}
                    type="text"
                    onChange={(ev) => {
                      formatCurrency(ev.target.value, setValorCurso);
                    }}
                    size={"small"}
                    color="primary"
                    label="Valor do Curso"
                  />
                </Grid>

                <Grid size={{ xs: 12, sm: 3, lg: 2.5, xl: 1 }}>
                  <TextField
                    fullWidth
                    placeholder="Valor de Venda"
                    value={valorVenda}
                    type="text"
                    onChange={(ev) => {
                      formatCurrency(ev.target.value, setValorVenda);
                    }}
                    size={"small"}
                    color="primary"
                    label="Valor de Venda"
                  />
                </Grid>

                <Grid size={{ xs: 12, sm: 3, lg: 1.5, xl: 0.75 }}>
                  <TextField
                    fullWidth
                    label="Parcelas"
                    value={parcelas}
                    onChange={(e) =>
                      setParcelas(e.target.value.replace(/\D/g, ""))
                    }
                    type="number"
                    size="small"
                    inputProps={{ min: 1, max: 36 }}
                  />
                </Grid>

                {editingStudent ? (
                  <Grid size={{ xs: 12, sm: 3, lg: 1.5, xl: 1.25 }}>
                    <TextField
                      fullWidth
                      select
                      label="Situação"
                      size="small"
                      value={statusMatricula}
                      onChange={(e) => setStatusMatricula(e.target.value)}
                    >
                      <MenuItem value="ativado">Ativado</MenuItem>
                      <MenuItem value="cancelado">Cancelado</MenuItem>
                      <MenuItem value="trancado">Trancado</MenuItem>
                      <MenuItem value="travado">Travado</MenuItem>
                      <MenuItem value="concluído">Concluído</MenuItem>
                    </TextField>
                  </Grid>
                ) : null}
              </Grid>
            </CardContent>
          </Card>

          <Card>
            <CardContent>
              <Grid container spacing={1}>
                <Grid size={{ xs: 12, md: 12 }}>
                  <Typography
                    sx={{
                      backgroundColor: Colors.titleRowWithBackgroundColor,
                      pl: 1,
                      pt: 0.75,
                      mt: -1,
                    }}
                    variant="body2"
                    color={Colors.titleWithBackgroudColor}
                  >
                    <People fontSize={"inherit"} /> Informações do Aluno
                  </Typography>
                </Grid>

                <Grid size={{ xs: 12, sm: 4, md: 3, xl: 2 }}>
                  <TextField
                    fullWidth
                    required
                    type="text"
                    label="CPF"
                    size="small"
                    value={cpf}
                    onChange={(e) => formatCPF(e.target.value, setCpf)}
                    disabled={editingStudent}
                    sx={{
                      "& .MuiInputLabel-root.Mui-disabled": {
                        color: (theme) => theme.palette.text.disabled,
                      },
                      "& .MuiOutlinedInput-root.Mui-disabled": {
                        backgroundColor: (theme) =>
                          theme.palette.action.disabledBackground,
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: (theme) => theme.palette.action.disabled,
                        },
                      },
                      "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: (theme) =>
                          theme.palette.text.disabled,
                      },
                    }}
                  />
                </Grid>

                <Grid size={{ xs: 12, sm: 4, md: 3, xl: 2 }}>
                  <TextField
                    fullWidth
                    placeholder="E-mail"
                    value={email}
                    required
                    type="text"
                    onChange={(ev) => {
                      setEmail(ev.target.value);
                    }}
                    size={"small"}
                    color="primary"
                    label="E-mail"
                    sx={{
                      "& .MuiInputLabel-root.Mui-disabled": {
                        color: (theme) => theme.palette.text.disabled,
                      },
                      "& .MuiOutlinedInput-root.Mui-disabled": {
                        backgroundColor: (theme) =>
                          theme.palette.action.disabledBackground,
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: (theme) => theme.palette.action.disabled,
                        },
                      },
                      "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: (theme) =>
                          theme.palette.text.disabled,
                      },
                    }}
                    disabled={editingStudent}
                  />
                </Grid>

                <Grid size={{ xs: 12, sm: 4, md: 3, xl: 2 }}>
                  <TextField
                    fullWidth
                    placeholder="Nome"
                    required
                    value={nome}
                    type="text"
                    onChange={(ev) => {
                      setNome(ev.target.value);
                    }}
                    size={"small"}
                    color="primary"
                    label="Nome"
                  />
                </Grid>

                <Grid size={{ xs: 12, sm: 4, md: 3, xl: 2 }}>
                  <TextField
                    label="CEP"
                    value={cep}
                    required
                    onChange={(e) =>
                      setCep(
                        e.target.value
                          .replace(/\D/g, "")
                          .slice(0, 8)
                          .replace(/(\d{5})(\d{1,3})/, "$1-$2"),
                      )
                    }
                    inputMode="numeric"
                    size="small"
                    fullWidth
                  />
                </Grid>

                <Grid size={{ xs: 12, sm: 6, md: 7, xl: 3 }}>
                  <TextField
                    fullWidth
                    required
                    placeholder="Logradouro"
                    value={logradouro}
                    type="text"
                    onChange={(ev) => {
                      setLogradouro(ev.target.value);
                    }}
                    size={"small"}
                    color="primary"
                    label="Logradouro"
                  />
                </Grid>

                <Grid size={{ xs: 12, sm: 2, md: 2, xl: 1 }}>
                  <TextField
                    fullWidth
                    required
                    placeholder="Número"
                    value={numero}
                    type="text"
                    onChange={(ev) => {
                      setNumero(ev.target.value);
                    }}
                    size={"small"}
                    color="primary"
                    label="Número"
                  />
                </Grid>

                <Grid size={{ xs: 12, sm: 4, md: 3, xl: 2 }}>
                  <TextField
                    fullWidth
                    required
                    placeholder="Bairro"
                    value={bairro}
                    type="text"
                    onChange={(ev) => {
                      setBairro(ev.target.value);
                    }}
                    size={"small"}
                    color="primary"
                    label="Bairro"
                  />
                </Grid>

                <Grid size={{ xs: 12, sm: 4, md: 3, xl: 1.7 }}>
                  <TextField
                    fullWidth
                    required
                    placeholder="Cidade IBGE"
                    value={cidadeIBGE}
                    type="text"
                    onChange={(ev) => {
                      setCidadeIBGE(ev.target.value);
                    }}
                    size={"small"}
                    color="primary"
                    label="Cidade IBGE"
                  />
                </Grid>

                <Grid size={{ xs: 12, sm: 4, md: 3, xl: 1.7 }}>
                  <TextField
                    fullWidth
                    placeholder="Telefone Celular"
                    value={telCelular}
                    type="text"
                    onChange={(ev) => {
                      formatTelefone(ev.target.value, setTelCelular);
                    }}
                    size={"small"}
                    color="primary"
                    label="Telefone Celular"
                  />
                </Grid>

                <Grid size={{ xs: 12, sm: 4, md: 3, xl: 1.7 }}>
                  <TextField
                    fullWidth
                    select
                    label="Sexo"
                    size="small"
                    value={sexo}
                    onChange={(e) => setSexo(e.target.value)}
                  >
                    <MenuItem value="masculino">Masculino</MenuItem>
                    <MenuItem value="feminino">Feminino</MenuItem>
                  </TextField>
                </Grid>

                <Grid size={{ xs: 12, sm: 4, md: 3, xl: 1.7 }}>
                  <TextField
                    fullWidth
                    placeholder="Nascimento"
                    value={nascimento}
                    type="date"
                    onChange={(ev) => {
                      const val = ev.target.value;
                      const [ano = "", mes = "", dia = ""] = val.split("-");

                      if (ano.length > 4) {
                        const ajustado = `${ano.slice(
                          0,
                          4,
                        )}-${mes}-${dia}`.replace(/-+$/g, "");
                        setNascimento(ajustado);
                      } else {
                        setNascimento(val);
                      }
                    }}
                    size="small"
                    color="primary"
                    label="Nascimento"
                    InputLabelProps={{ shrink: true }}
                    inputProps={{
                      maxLength: 10,
                    }}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          <Card>
            <CardContent>
              <Grid container spacing={1}>
                <Grid size={{ xs: 12, md: 12 }}>
                  <Typography
                    sx={{
                      backgroundColor: Colors.titleRowWithBackgroundColor,
                      pl: 1,
                      pt: 0.75,
                      mt: -1,
                    }}
                    variant="body2"
                    color={Colors.titleWithBackgroudColor}
                  >
                    <AddCard fontSize="inherit" /> Informações de cobrança
                  </Typography>
                </Grid>

                <Grid container direction="column" spacing={2}>
                  {cobrancas.map((row, index) => (
                    <Grid key={index}>
                      <Grid container spacing={1} alignItems="center">
                        <Grid size={{ xs: 12, sm: 4, md: 3, xl: 1.5 }}>
                          <TextField
                            fullWidth
                            placeholder="Valor total"
                            value={row.valorTotal}
                            type="text"
                            onChange={(ev) =>
                              setCurrencyField(
                                index,
                                "valorTotal",
                                ev.target.value,
                              )
                            }
                            size="small"
                            color="primary"
                            label="Valor Total"
                          />
                        </Grid>

                        <Grid size={{ xs: 12, sm: 4, md: 3, xl: 1.75 }}>
                          <TextField
                            fullWidth
                            placeholder="Data de Vencimento"
                            value={row.dataVencimento}
                            type="date"
                            onChange={(ev) =>
                              setDateField(
                                index,
                                "dataVencimento",
                                ev.target.value,
                              )
                            }
                            size="small"
                            color="primary"
                            label="Data de Vencimento"
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ maxLength: 10 }}
                          />
                        </Grid>

                        <Grid size={{ xs: 12, sm: 4, md: 3, xl: 2.25 }}>
                          <TextField
                            label="Texto Parcela: MM/MM"
                            value={row.textoParcela}
                            onChange={(e) =>
                              setField(index, "textoParcela", e.target.value)
                            }
                            inputMode="numeric"
                            size="small"
                            fullWidth
                          />
                        </Grid>

                        <Grid size={{ xs: 12, sm: 4, md: 3, xl: 1.5 }}>
                          <TextField
                            fullWidth
                            placeholder="Ordem parcela"
                            value={row.ordemParcela}
                            type="text"
                            onChange={(ev) =>
                              setField(index, "ordemParcela", ev.target.value)
                            }
                            size="small"
                            color="primary"
                            label="Ordem parcela"
                          />
                        </Grid>

                        <Grid size={{ xs: 12, sm: 4, md: 3, xl: 1.5 }}>
                          <TextField
                            fullWidth
                            placeholder="Valor Pago"
                            value={row.valorPago}
                            type="text"
                            onChange={(ev) =>
                              setCurrencyField(
                                index,
                                "valorPago",
                                ev.target.value,
                              )
                            }
                            size="small"
                            color="primary"
                            label="Valor Pago"
                          />
                        </Grid>

                        <Grid size={{ xs: 12, sm: 4, md: 3, xl: 1.75 }}>
                          <TextField
                            fullWidth
                            placeholder="Data de Pagamento"
                            value={row.dataPagamento}
                            type="date"
                            onChange={(ev) =>
                              setDateField(
                                index,
                                "dataPagamento",
                                ev.target.value,
                              )
                            }
                            size="small"
                            color="primary"
                            label="Data de Pagamento"
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ maxLength: 10 }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          <Card>
            <CardContent>
              <Grid container spacing={1}>
                <Grid size={{ xs: 12 }}>
                  <Typography
                    sx={{
                      backgroundColor: Colors.titleRowWithBackgroundColor,
                      pl: 1,
                      pt: 0.75,
                      mt: -1,
                    }}
                    variant="body2"
                    color={Colors.titleWithBackgroudColor}
                  >
                    <EditDocument fontSize="inherit" /> Documentos
                  </Typography>
                </Grid>

                {docs.map((row, index) => (
                  <React.Fragment key={index}>
                    <input
                      ref={(el) => {
                        if (el) fileInputsRef.current[index] = el;
                      }}
                      type="file"
                      accept="image/*,application/pdf"
                      hidden
                      onChange={(e) =>
                        handleFileSelected(index, e.target.files?.[0] ?? null)
                      }
                    />

                    <Grid size={{ xs: 12, sm: 12, md: 6, lg: 5, xl: 4 }}>
                      <TextField
                        fullWidth
                        select
                        label="Tag"
                        size="small"
                        required
                        value={row.tag}
                        onChange={(e) =>
                          handleTagChange(index, e.target.value as TagValue)
                        }
                      >
                        {TAG_OPTIONS.map((opt) => (
                          <MenuItem key={opt.value} value={opt.value}>
                            {opt.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>

                    <Grid size={{ xs: 12, sm: 10, md: 4, lg: 5, xl: 4 }}>
                      {row.file ? (
                        <TextField
                          label="Documento"
                          size="small"
                          fullWidth
                          required
                          value={row.file.name}
                          inputProps={{ readOnly: true }}
                          InputProps={{
                            endAdornment: (
                              <Tooltip title="Alterar documento">
                                <IconButton
                                  size="small"
                                  onClick={() => triggerFilePicker(index)}
                                  edge="end"
                                >
                                  <FileUpload fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            ),
                          }}
                        />
                      ) : (
                        <Button
                          variant="outlined"
                          fullWidth
                          onClick={() => triggerFilePicker(index)}
                        >
                          Selecionar Documento *
                        </Button>
                      )}
                    </Grid>

                    <Grid
                      size={{ xs: 12, sm: 2, md: 2, lg: 2, xl: 2 }}
                      sx={{ display: "flex", alignItems: "center", gap: 1 }}
                    >
                      <Tooltip title="Adicionar outro documento">
                        <IconButton color="primary" onClick={handleAddRow}>
                          <Add />
                        </IconButton>
                      </Tooltip>

                      {!editingStudent ? (
                        <>
                          {docs.length > 1 && (
                            <Tooltip title="Remover esta linha">
                              <IconButton
                                color="error"
                                onClick={() => handleRemoveRow(index)}
                              >
                                <DeleteOutline />
                              </IconButton>
                            </Tooltip>
                          )}
                        </>
                      ) : null}
                    </Grid>
                  </React.Fragment>
                ))}
              </Grid>
            </CardContent>
          </Card>

          <Grid size={{ xs: 12 }} textAlign={"center"}>
            <Button
              variant="outlined"
              color="primary"
              sx={{
                "&:disabled": {
                  color: Colors.muiPrimary,
                },
              }}
              onClick={() => cadastrarAluno()}
            >
              {isWaiting ? <CircularProgress size={20} /> : "Confirmar"}
            </Button>
          </Grid>
        </Box>
      ) : null}

      {loading ? (
        <Box
          width={"100%"}
          height={"45vh"}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Grid
            size={{ xs: 12, md: 12 }}
            textAlign={"center"}
            justifyContent={"center"}
            alignItems={"center"}
            bgcolor={"#eceff9ff"}
            borderRadius={5}
            padding={5}
            color={Colors.noResultFont}
          >
            <div
              style={{
                marginTop: "-0.5rem",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress color="primary" />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <p
                style={{
                  color: "#4b4b4b",
                  fontSize: 14,
                  marginBottom: "-1rem",
                }}
              >
                {titleLoading}
              </p>
            </div>
          </Grid>
        </Box>
      ) : null}

      {notFound ? (
        <Box
          width={"100%"}
          height={"45vh"}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Grid
            size={{ xs: 12, md: 12 }}
            height={{ md: "20%", xs: "50%" }}
            display={"inline-flex"}
            textAlign={"center"}
            justifyContent={"center"}
            alignItems={"center"}
            bgcolor={"lightyellow"}
            borderRadius={5}
            padding={5}
            color={Colors.noResultFont}
          >
            <p
              style={{
                color: "#4b4b4b",
                fontSize: 14,
              }}
            >
              Sua pesquisa não retornou nenhum resultado.
            </p>
          </Grid>
        </Box>
      ) : null}

      <ValidationDialog
        open={valModalOpen}
        onClose={() => setValModalOpen(false)}
        errors={valErrors}
        showProceed={hasWarningOnly} // Definido na lógica que te passei antes
        onProceed={() => {
          setValModalOpen(false);
          cadastrarAluno(true); // <--- O BYPASS AQUI: Chama a função ignorando o erro do mês
        }}
      />
    </>
  );
};

const styles = StyleSheet.create({
  pageTitle: {
    fontFamily: "Poppins",
    fontWeight: 600,
    color: "#4b4b4b",
  },
  input: {
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 400,
    color: "#808080",
    transitionDuration: "0.2s",
  },
  btn: {
    backgroundColor: "#669966",
    color: "#fff",
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 600,
    borderStyle: "solid",
    borderWidth: 0.5,
    borderColor: "#669966",
    borderRadius: 6,
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    padding: "0.5rem 0.3rem 0.42rem 0.4rem",
    width: "100%",
    marginTop: "1.95rem",
    transitionDuration: "0.2s",
    ":hover": {
      color: "#669966",
      backgroundColor: "transparent",
      borderColor: "#669966",
    },
    ":active": {
      color: "#669966",
      backgroundColor: "transparent",
      borderColor: "#669966",
      opacity: 0.6,
    },
  },
  btnDisabled: {
    color: "#fff",
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 600,
    borderStyle: "solid",
    borderWidth: 0.5,
    borderRadius: 6,
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    padding: "0.5rem 0.5rem 0.5rem 0.5rem",
    transitionDuration: "0.2s",
    backgroundColor: "#B3B3B3",
    borderColor: "#B3B3B3",
  },
  erro: {
    fontSize: 14,
    color: "red",
    textAlign: "center",
    fontWeight: 600,
    marginTop: "1rem",
    marginBottom: "-0.5rem",
  },
  topBtn: {
    cursor: "pointer",
    backgroundColor: "#004AAD",
    color: "#fff",
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 600,
    borderStyle: "solid",
    borderWidth: 0.5,
    borderColor: "#004AAD",
    borderRadius: 6,
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    padding: "0.5rem 0.5rem 0.5rem 0.5rem",
    transitionDuration: "0.2s",
    ":hover": {
      color: "#186ad6ff",
      backgroundColor: "transparent",
      borderColor: "#186ad6ff",
    },
    ":active": {
      color: "#004AAD",
      backgroundColor: "transparent",
      borderColor: "#004AAD",
      opacity: 0.6,
    },
  },
});
